/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoResourceSelect implements angular.IDirective {
        
        restrict = "E";
        scope = {
            itemTemplateUrl: "@",
            baseEndpoint: "@",
            model: "=ngModel",
            items: "=",
            change: "&?ngChange",
            required: "=ngRequired",
            focus: "&ngFocus",
            cancelSelection: "&",
            bookingItemDisplayName: "=",
            disabled: "=ngDisabled"
        }

        template = `<div style="position:relative">
                        <meevo-auto-capitalization-field ng-model="textModel.displayName" ng-required="required" content-key="LABEL_RESOURCE" style="width:100%" ng-disabled="true"></meevo-auto-capitalization-field>
                        <md-select ng-model="selectModel"  md-on-close="close()" ng-focus="focus()" ng-disabled="disabled">
                            <md-option value="{{item.id}}" ng-repeat="item in items">
                                <div layout="row">
                                        <div ng-if="item.id != 0">
                                            <div ng-class="{'resource-available': !item.isBooked && !item.isOffHours && !item.isResourceRestricted,
                                                            'resource-double': ((item.isBooked && item.isDoubleBookable) || item.isResourceRestricted) && !item.isOffHours && !item.isMaxCapacity,
                                                            'resource-unavailable': item.isOffHours || (item.isBooked && (!item.isDoubleBookable || item.isMaxCapacity))}"></div>
                                        </div>
                                        <div>{{ item.displayName }}</div>
                                    </div>
                            </md-option>
                        </md-select>
                    </div>`;
        
                    
        link = (scope: any, element: JQuery, attrs) => {
            // Need a separate textModel b/c when setting the resource to undefined, binding to displayName will recreate model with just blank displayName
            scope.$watch("model", function () {
                scope.textModel = scope.model;
            });
            
            scope.close = () => {
                if (scope.selectModel) {
                    if (scope.selectModel == "0") {
                        scope.assignModel(undefined);
                    } else if (!scope.model || scope.model.id != scope.selectModel) {
                        let newModel: any = _.findWhere(scope.items, { id: scope.selectModel });
                        
                        let translateDictionary = {
                            resourceDisplayName: newModel.displayName,
                            bookingItemDisplayName: scope.bookingItemDisplayName
                        };

                        if (newModel.isAvailable) {
                          scope.assignModel(newModel);
                        }
                        else if (newModel.isMaxCapacity) {
                            this.modal.showMessage(this.$translate.instant("MESSAGE_RESOURCE_MAX_CAPACITY", translateDictionary));
                            scope.selectModel = undefined;
                        }
                        else if (newModel.isBooked && newModel.isDoubleBookable) {
                            this.security.checkSecurityKey(Meevo.Components.Common.SecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_ACTION_DOUBLEBOOKRESOURCE).then(result => {
                                if (result === Meevo.Model.SecurityAccessEnum.Grant) {
                                    scope.assignModel(newModel);
                                } else {
                                    this.modal.showMessage(this.$translate.instant("MESSAGE_RESOURCE_NO_BOOK", translateDictionary));
                                    scope.selectModel = undefined;
                                }
                            });
                        }
                        else if (!newModel.isBooked && newModel.isOffHours) {
                            this.modal.showMessage(this.$translate.instant("MESSAGE_RESOURCE_NOT_AVAILABLE", translateDictionary),
                            {
                                buttonsType: Meevo.Model.ButtonTypeEnum.YesNo,
                                callback: (response) => {
                                    if (response == Meevo.Model.MessageBoxButtonResult.Yes) {
                                        scope.assignModel(newModel);
                                    } else {
                                        if (attrs.cancelSelection != undefined) {
                                            scope.cancelSelection();
                                        }
                                        scope.selectModel = undefined;
                                    }
                                }
                            });
                        }
                        else if (newModel.isResourceRestricted) {
                            scope.assignModel(newModel);
                        }

                        else {
                            this.modal.showMessage(this.$translate.instant("MESSAGE_RESOURCE_NO_BOOK", translateDictionary));
                            scope.selectModel = undefined;
                        } 
                    }
                }
            }

            scope.assignModel = (model)=>
            {
                scope.model = model;
                
                if (scope.change) {
                    this.timeout(function () {
                        scope.change();
                    });
                }
            }
        }
        
        constructor(private timeout: any, private modal: any, private security: any, private $translate:any) {
            
        }


        static factory(): angular.IDirectiveFactory {
            let directive = (timeout: any, modal, security, $translate) => {
                return new MeevoResourceSelect(timeout, modal, security, $translate);
            }
            directive.$inject = ["$timeout", "appointmentBookModalService", 'meevo.components.common.SecurityService','$translate'];
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoResourceSelect", MeevoResourceSelect.factory());
}